import type { ReactNode } from "react";
import { Link } from "react-router";
import { useGoBack } from "../phone/history";
import { Icon } from "../ui/Icon";

/**
 * The top of a screen opened from another (`.k-nav`): a labelled Back at the left, the title in the middle and one
 * optional action at the right. Back steps through history when that is where the person came from, as the phone does.
 */
export function PushedNav({
  back,
  title,
  right,
}: {
  /** `onBack` is for a back that must ask first (unsaved edits). */
  back: { to: string; label: string; onBack?: () => void };
  title?: ReactNode;
  /** The one action at the right: a `k-link` or an icon button. */
  right?: ReactNode;
}) {
  const goBack = useGoBack();
  return (
    <div className="k-nav">
      <Link
        to={back.to}
        className="k-back"
        aria-label={`Back to ${back.label}`}
        onClick={(e) => {
          e.preventDefault();
          if (back.onBack) back.onBack();
          else goBack(back.to);
        }}
      >
        <Icon name="left" />
        <span>{back.label}</span>
      </Link>
      <span className="k-nav-t">{title}</span>
      <span className="k-nav-r">{right}</span>
    </div>
  );
}
